/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from "react";
import {css} from "@emotion/react";


export default function CommonKnobsContainer({children}) {

	return (
		<div css={knobsContainer}>
			{children}
		</div>
	)
}

const knobsContainer = css`
	display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 12px;
  margin-bottom: 24px;
`;
